import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { dailyConditionsApi } from '../api';
import type { DailyConditionListParams } from '../api/dailyConditions';

export const useDailyConditionStats = (days = 14) => {
  return useQuery({
    queryKey: ['daily-conditions', 'stats', days],
    queryFn: () => dailyConditionsApi.getStats(days),
  });
};

export const useDailyConditionList = (params: DailyConditionListParams) => {
  return useQuery({
    queryKey: ['daily-conditions', 'list', params],
    queryFn: () => dailyConditionsApi.list(params),
    // Keep the current page visible while the next filter/page loads
    placeholderData: keepPreviousData,
  });
};

export const useDailyConditionTable = (day: string) => {
  return useQuery({
    queryKey: ['daily-conditions', 'table', day],
    queryFn: () => dailyConditionsApi.getTable(day),
    enabled: !!day,
    placeholderData: keepPreviousData,
  });
};

export const useDailyCondition = (id: string | null) => {
  return useQuery({
    queryKey: ['daily-conditions', 'detail', id],
    queryFn: () => dailyConditionsApi.get(id as string),
    enabled: !!id,
  });
};
